<template>
  <v-flex>
    <v-dialog
      v-if="this.modelBici"
      v-model="dialogFormularioBici"
      :max-width="600"
      persistent
    >
      <bici-formulario
        @cerrarFormularioBici="dialogFormularioBici = false"
        :modelBici="this.modelBici"
        :accion="this.accion"
      />
    </v-dialog>

    <v-dialog v-model="showConfirmacionEliminacion" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon
            size="30"
            :color="'white'"
            @click="showConfirmacionEliminacion = false"
            >mdi-close-circle</v-icon
          >
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar la bici?
            </v-label>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip
              class="mr-4"
              label
              color="blue-grey darken-3"
              @click="_eliminarBici()"
            >
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip
              label
              class="ml-4"
              color="blue-grey darken-3"
              @click="showConfirmacionEliminacion = false"
            >
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="mt-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense color="blue-grey darken-2" flat>
        <v-toolbar-title :dark="!dark">BICIS</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- <v-chip class="mr-4" :color="colorAccent2" link @click="_imprimir">
          <v-avatar left>
            <v-icon size="20" color="white">mdi-printer</v-icon>
          </v-avatar>
          <h5 v-bind:style="{ color: 'white' }">IMPRIMIR</h5>
        </v-chip> -->
        <v-chip
          class="mr-1"
          link
          :color="colorEBikeAccent1"
          @click="_crearBici"
        >
          <v-avatar left>
            <v-icon size="20" color="white">mdi-account-plus</v-icon>
          </v-avatar>
          <h5 v-bind:style="{ color: 'white' }">NUEVA BICI</h5>
        </v-chip>
      </v-toolbar>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear
            class="mt-12 mb-12"
            :color="colorEBikeAccent1"
            indeterminate
            width="200px"
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="mt-2 mb-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>
        <v-row v-if="bicis" class="mt-0" justify="start" dense>
          <v-col cols="12" align="center">
            <v-data-table
              locale="es"
              v-if="bicis"
              dense
              light
              :headers="headersLargo"
              :items="bicis"
              :items-per-page="bicis.length"
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:[`item.action`]="{ item }">
                <v-chip
                  class="mr-1"
                  label
                  small
                  :color="colorAccent2"
                  text-color="white"
                  link
                  @click="_editar(item)"
                >
                  Editar
                </v-chip>

                <v-chip
                  label
                  small
                  color="red lighten-2"
                  text-color="white"
                  link
                  @click="_delete(item)"
                >
                  Eliminar
                </v-chip>

                
              </template>

              <template v-slot:[`item.posicion`]="{ item }">
                
                <v-icon
                  v-if="!esPrimero(item)"
                  @click="_subirPosicion(item)"
                  :color="'green'"
                  class="mr-2">
                  mdi-arrow-up-bold</v-icon>

                  <v-icon
                  v-else
                  :color="'transparent'"
                  class="mr-2">
                  mdi-arrow-up-bold</v-icon>

                <v-icon
                v-if="!esUltimo(item)"
                  @click="_bajarPosicion(item)"
                  :color="'green'"
                  class="ml-0"
                  
                  >mdi-arrow-down-bold</v-icon
                >

                <v-icon
                v-else
                  :color="'transparent'"
                  class="ml-0"
                  
                  >mdi-arrow-down-bold</v-icon
                >
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import BiciFormulario from "../components/formularios/BiciFormulario";

export default {
  components: {
    BiciFormulario,
  },

  data: () => ({
    mostrarbusqueda: true,
    accion: "",

    dialogFormularioBici: false,
    modelBici: null,
    showConfirmacionEliminacion: false,

    headersLargo: [
      // { text: "ID", width: "80px", align: "left", sortable: false, value: "id" },
      {
        text: "NUMERO",
        align: "left",
        sortable: false,
        value: "numero",
      },
      { text: "TALLA", align: "left", sortable: false, value: "talla" },
      {
        text: "MARCA",
        align: "left",
        sortable: false,
        value: "marca",
      },
      {
        text: "OBSERVACIONES",
        align: "left",
        sortable: false,
        value: "observaciones",
      },
      {
        text: "ACCIONES",
        width: "170px",
        value: "action",
        sortable: false,
        align: "center",
      },
      {
        text: "POSICIÓN",
        width: "100px",
        value: "posicion",
        sortable: false,
        align: "center",
      },
    ],
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorEBikeAccent1",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("bicis", ["bicis", "biciSelec"]),
  },

  watch: {},

  mounted() {
    this._getBicis(true);
  },

  methods: {
    ...mapActions("bicis", ["getBicis", "eliminarBici", "updateBici", "subirPosicion", "bajarPosicion"]),
    ...mapMutations("bicis", ["setBiciSelec"]),

    _inicializarModelBici() {
      this.modelBici = {
        id: null,
        numero: null,
        talla: null,
        marca: null,
        observaciones: null,
        ordenar_inicio: 0,
      };
    },

    async _subirPosicion(item){
      var res = await this.subirPosicion([this.access_token, item.id]);
      if (res != null) {
        this._getBicis(false);
      }
    },

    async _bajarPosicion(item){
      var res = await this.bajarPosicion([this.access_token, item.id]);
      if (res != null) {
        this._getBicis(false);
      }
    },

    esPrimero(item){
      if (this.bicis.length > 0 && item.id == this.bicis[0].id) {
        return true;
       }else{
        return false;
       }
    },

    esUltimo(item){
      if (this.bicis.length > 0 && item.id == this.bicis[this.bicis.length-1].id) {
        return true;
       }else{
        return false;
       }
    },



    _imprimir() {},

    async _getBicis(showload) {
      const params = {};
      await this.getBicis([this.access_token, params, showload]);
    },

    _delete(item) {
      this.setBiciSelec(item);
      this.showConfirmacionEliminacion = true;
    },

    _crearBici() {
      this._inicializarModelBici();
      this.accion = "crear";
      this.dialogFormularioBici = true;
    },

    _editar(item) {
      this.setBiciSelec(item);
      let temp = JSON.parse(JSON.stringify(this.biciSelec));
      this.modelBici = temp;
      this.accion = "editar";
      this.dialogFormularioBici = true;
    },

    async _eliminarBici() {
      this.showConfirmacionEliminacion = false;
      if (this.biciSelec != null) {
        await this.eliminarBici([this.access_token, this.biciSelec.id]);
      }
    },
  },
};
</script>
